import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { ORGANIZATION_LIST } from './url-constants';

type OrganizationListEndpointSpecification = ApiEndpointSpecification;
export const OrganizationListEndpointSpecification: OrganizationListEndpointSpecification = {
    url: ORGANIZATION_LIST,
    method: HttpMethod.GET,
    requestParamsSchemaName: 'OrganizationListRequestParams',
    requestBodySchemaName: 'OrganizationListRequestBody',
    okResponseSchemaName: 'OrganizationListOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
};

export const invokeOrganizationList = Helpers.makeApiRequestFn<
    Types.OrganizationListRequestParams,
    Types.OrganizationListRequestBody,
    Types.OrganizationListOkResponse
>(OrganizationListEndpointSpecification);
